import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { FaSearch, FaFilter, FaFileDownload } from 'react-icons/fa';
import DetailModal from '../Incharge/DetailModal';

const EngineerEngineerLotteryList = () => {
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedTaluka, setSelectedTaluka] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (!user) {
                navigate('/login');
            } else {
                // Fetch current user's role
                const userRef = ref(db, `ekamwatapzp/users/${user.uid}`);
                onValue(userRef, (snapshot) => {
                    if (snapshot.exists()) {
                        setUserRole(snapshot.val().role);
                    }
                });
            }
        });

        const registrationsRef = ref(db, 'ekamwatapzp/EngineerRegistrations');
        const unsubData = onValue(registrationsRef, (snapshot) => {
            if (snapshot.exists()) {
                const allEngineers = snapshot.val();
                const lotteryList = [];
                
                Object.keys(allEngineers).forEach(whatsappNo => {
                    const engineerData = allEngineers[whatsappNo];
                    if (engineerData.lotteryregistration) {
                        lotteryList.push({
                            id: whatsappNo,
                            ...engineerData.lotteryregistration
                        });
                    }
                });
                
                setRegistrations(lotteryList.reverse());
            } else {
                setRegistrations([]);
            }
            setLoading(false);
        });

        return () => {
            unsubscribe();
            unsubData();
        };
    }, [navigate]);

    const handleStatusUpdate = async (id, updateData) => {
        const itemRef = ref(db, `ekamwatapzp/EngineerRegistrations/${id}/lotteryregistration`);
        await update(itemRef, updateData);
    };

    const filteredData = registrations.filter(item => {
        const fullName = `${item.firstName} ${item.middleName} ${item.surname}`.toLowerCase();
        const matchesSearch = fullName.includes(searchTerm.toLowerCase());
        const matchesTaluka = selectedTaluka === '' || item.taluka === selectedTaluka;
        return matchesSearch && matchesTaluka;
    });

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <EngineerLayout>
            <div className="p-8">
                <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800">सु. बे. अभियंता लॉटरी अर्ज यादी</h1>
                        <p className="text-gray-500">एकूण नोंदणी: {filteredData.length}</p>
                    </div>
                    <button className="flex items-center space-x-2 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition">
                        <FaFileDownload />
                        <span>Excel डाउनलोड</span>
                    </button>
                </div>

                {/* Filters */}
                <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6 flex flex-col md:flex-row gap-4">
                    <div className="flex-grow relative">
                        <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input 
                            type="text" 
                            placeholder="नाव शोध..." 
                            className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="flex items-center space-x-2">
                        <FaFilter className="text-gray-400" />
                        <select 
                            className="bg-white border border-gray-200 rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
                            value={selectedTaluka}
                            onChange={(e) => setSelectedTaluka(e.target.value)}
                        >
                            <option value="">सर्व तालुके</option>
                            <option value="Miraj">मिरज</option>
                            <option value="Tasgaon">तासगाव</option>
                            <option value="Kavathe Mahankal">कवठे महांकाळ</option>
                            <option value="Walwa">वाळवा</option>
                            <option value="Shirala">शिराळा</option>
                            <option value="Khanapur">खानापूर</option>
                            <option value="Atpadi">आटपाडी</option>
                            <option value="Jat">जत</option>
                            <option value="Kadegaon">कडेगाव</option>
                            <option value="Palus">पलूस</option>
                        </select>
                    </div>
                </div>

                <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr className="bg-blue-600 text-white">
                                    <th className="px-4 py-4 text-xs font-black uppercase tracking-wider text-center border-b border-blue-500 w-16">अ.क्र.</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider border-b border-blue-500">नाव</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider border-b border-blue-500">तालुका</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider border-b border-blue-500">मोबाईल</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider border-b border-blue-500">नोंदणी क्र.</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider border-b border-blue-500">परवाना संपण्याची तारीख</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider border-b border-blue-500">दिनांक</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider border-b border-blue-500">स्थिती</th>
                                    <th className="px-6 py-4 text-xs font-black uppercase tracking-wider text-center border-b border-blue-500">कृती</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                            {filteredData.map((item, index) => (
                                <tr key={item.id} className="hover:bg-blue-50/50 transition-colors border-b border-gray-200">
                                    <td className="px-4 py-4 text-center text-sm font-bold text-gray-500 border-r border-gray-200">
                                        {index + 1}
                                    </td>
                                    <td className="px-6 py-4 border-r border-gray-200">
                                        <div className="font-bold text-gray-800">{item.firstName} {item.surname}</div>
                                        <div className="text-[10px] text-blue-600 font-bold uppercase tracking-tight">{item.email}</div>
                                    </td>
                                    <td className="px-6 py-4 text-sm font-bold text-gray-700 border-r border-gray-200">{item.taluka}</td>
                                    <td className="px-6 py-4 text-sm font-bold text-gray-700 border-r border-gray-200">{item.whatsappNo}</td>
                                    <td className="px-6 py-4 text-sm font-bold text-gray-700 border-r border-gray-200">{item.registrationNo}</td>
                                    <td className="px-6 py-4 text-sm font-bold text-red-600 border-r border-gray-200">{item.licenseEndDate}</td>
                                    <td className="px-6 py-4 text-sm font-bold text-gray-500 border-r border-gray-200">
                                        {item.submittedAt ? new Date(item.submittedAt).toLocaleDateString() : '-'}
                                    </td>
                                    <td className="px-6 py-4 text-sm border-r border-gray-200">
                                        <span className={`px-2 py-1 rounded text-xs font-black border ${
                                            item.status === 'accepted' ? 'bg-green-100 text-green-700 border-green-200 shadow-sm shadow-green-100' : 
                                            item.status === 'rejected' ? 'bg-red-100 text-red-700 border-red-200 shadow-sm shadow-red-100' : 
                                            'bg-yellow-100 text-yellow-700 border-yellow-200 shadow-sm shadow-yellow-100'
                                        }`}>
                                            {item.status === 'accepted' ? 'स्वीकारले' : item.status === 'rejected' ? 'नाकारले' : 'प्रलंबित'}
                                        </span>
                                    </td>
                                    <td className="px-6 py-4 text-center">
                                        <button 
                                            onClick={() => {
                                                setSelectedItem(item);
                                                setIsModalOpen(true);
                                            }}
                                            className="text-white bg-blue-600 hover:bg-blue-700 text-xs font-black px-4 py-2 rounded-xl transition-all shadow-lg shadow-blue-100 active:scale-95"
                                        >
                                            तपशील पहा
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {filteredData.length === 0 && (
                        <div className="p-8 text-center text-gray-500 font-bold italic">
                            कोणतीही नोंदणी आढळली नाही.
                        </div>
                    )}
                </div>
            </div>

                <DetailModal 
                    isOpen={isModalOpen} 
                    onClose={() => setIsModalOpen(false)} 
                    data={selectedItem} 
                    title="सु. बे. अभियंता लॉटरी अर्ज"
                    onStatusUpdate={handleStatusUpdate}
                    registrations={registrations}
                    userRole={userRole}
                />
            </div>
        </EngineerLayout>
    );
};

export default EngineerEngineerLotteryList;
